var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bottom-bar" }, [
    _c("ul", { staticClass: "save-bar save-bar_type_horizontal" }, [
      _c("li", { staticClass: "save-bar__item" }, [
        _c(
          "button",
          {
            staticClass: "button green",
            attrs: { disabled: _vm.disabled },
            on: { click: _vm.saveStart }
          },
          [_vm._v("Сохранить")]
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "save-bar__item" }, [
        _vm.saved && !_vm.error
          ? _c("div", [
              _c("i", { staticClass: "icon16 yes" }),
              _vm._v(" "),
              _c("span", [_vm._v("Сохранено")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.saving && !_vm.error
          ? _c("div", [
              _c("i", { staticClass: "icon16 loading" }),
              _vm._v(" "),
              _c("span", { staticClass: "ajax-status__text" }, [
                _vm._v("Сохранение")
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.error
          ? _c("div", { staticClass: "ajax-status_type_error" }, [
              _c("i", { staticClass: "icon16 exclamation-red" }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.error))])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a583624", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a583624","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/settings/components/SaveBar.vue
// module id = 97
// module chunks = 0